// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__34Nbx","name":"Header_name__2B_oz","birthday":"Header_birthday__2vNQU","skeleton":"Header_skeleton__3BIuC"};